import { type BaselineFilters } from "./types";

export const WIZARD_STEPS = [
  "select-baseline-days",
  "adjust-for-profitability",
  "adjust-for-promotions-and-outliers",
  "adjust-for-incrementality",
  "adopt-benchmark",
] as const;

export const WIZARD_STEP_LABELS = {
  "select-baseline-days": "Select Baseline Days",
  "adjust-for-profitability": "Adjust for Profitability",
  "adjust-for-promotions-and-outliers": "Promotions & Outliers",
  "adjust-for-incrementality": "Add Custom Benchmark",
  "adopt-benchmark": "Adopt Benchmark",
} as const;

export const WIZARD_STEP_ICONS = {
  "select-baseline-days": "fa-calendar-range",
  "adjust-for-profitability": "fa-cash-register",
  "adjust-for-promotions-and-outliers": "fa-gift",
  "adjust-for-incrementality": "fa-regular fa-sliders",
  "adopt-benchmark": "fa-regular fa-dumbbell",
} as const;

export const KPI_FILTER_EQUATION_LABELS = {
  gt: "Greater than",
  lt: "Lower than",
} as const;

export const DATE_RANGE_CHOICES = [
  {
    value: "last30Days",
    label: "30 Day",
    labelForSelect: "last 30 days",
    unit: "days",
    amount: 30,
    className: undefined,
  },
  {
    value: "last60Days",
    label: "60 Day",
    labelForSelect: "last 60 days",
    unit: "days",
    amount: 60,
    className: undefined,
  },
  {
    value: "last3Months",
    label: "3 Month",
    labelForSelect: "last 3 months",
    unit: "months",
    amount: 3,
    className: undefined,
  },
  {
    value: "last6Months",
    label: "6 Month",
    labelForSelect: "last 6 months",
    unit: "months",
    amount: 6,
    className: undefined,
  },
  {
    value: "last12Months",
    label: "12 Month",
    labelForSelect: "last 12 months",
    unit: "month",
    amount: 12,
    className: undefined,
  },
  {
    value: "last18Months",
    label: "18 Month",
    labelForSelect: "last 18 months",
    unit: "months",
    amount: 18,
    className: undefined,
  },
  {
    value: "custom",
    label: "Custom",
    labelForSelect: "Custom",
    unit: "days",
    amount: 30,
    className: "flex-none w-10",
  },
] as const;

export const DEFAULT_BASELINE_FILTERS: BaselineFilters = {
  dateRange: "last12Months",
  cogs: {
    spend: { selected: "percent", value: 0 },
    otherMarketingCosts: { selected: "percent", value: 0 },
    discounts: { selected: "percent", value: 0 },
    shipping: { selected: "percent", value: 0 },
    taxes: { selected: "percent", value: 0 },
    returns: { selected: "percent", value: 0 },
    productCosts: { selected: "percent", value: 0 },
    otherCosts: { selected: "percent", value: 0 },
  },
  profitableDayThreshold: {
    enabled: true,
    value: 0,
    method: "blended",
    equation: "is-greater-or-equal-to-costs",
  },
  discountsThreshold: {
    enabled: true,
    value: 20,
    method: "blended",
  },
  lowestRevenueThreshod: { enabled: true, value: 5 },
  highestRevenueThreshod: { enabled: true, value: 5 },
  lowestSpendThreshod: { enabled: true, value: 5 },
  highestSpendThreshod: { enabled: true, value: 5 },
  lowestOrdersThreshod: { enabled: true, value: 5 },
  highestOrdersThreshod: { enabled: true, value: 5 },
  excludedDateRanges: [],
  kpiFilters: [],
  adjustment: null,
};
